import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";
import Reveal from "../ui/Reveal";
import SectionLabel from "../ui/SectionLabel";

function About() {
  return (
    <Section id="about" aria-labelledby="about-heading">
      <SectionLabel>About me</SectionLabel>
      <AboutGrid>
        <Reveal as="h2" id="about-heading">
          A detail-oriented developer with a product mindset.
        </Reveal>
        <Reveal as="div" delay={0.1}>
          <p>
            I'm Priyanshu, a MERN stack developer who enjoys translating complex requirements into interfaces
            that are clear, useful, and a pleasure to navigate. Across my internships I've worked on production
            systems end to end — from database schema to the pixels a user sees.
          </p>
          <p>
            I care about reusable component design, clean REST API integration, and the small details that make
            an application feel reliable in real-world use.
          </p>
          <InlineLink href="#contact">
            Let's work together <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
          </InlineLink>
        </Reveal>
      </AboutGrid>
    </Section>
  );
}

const Section = styled.section`
  max-width: 1240px;
  margin: auto;
  padding: 100px 28px;

  @media (max-width: 700px) {
    padding: 70px 24px;
  }
`;

const AboutGrid = styled.div`
  display: grid;
  grid-template-columns: 1.1fr 0.9fr;
  gap: 100px;

  h2 {
    font-size: clamp(2.2rem, 4.2vw, 3.6rem);
    letter-spacing: -0.03em;
    line-height: 1.1;
    color: var(--text-primary);
    margin: 0;
  }

  p {
    color: var(--text-secondary);
    line-height: 1.7;
    font-size: 1rem;
    margin: 0 0 17px;
  }

  @media (max-width: 760px) {
    grid-template-columns: 1fr;
    gap: 35px;
  }
`;

const InlineLink = styled.a`
  display: inline-block;
  margin-top: 12px;
  color: var(--text-primary);
  text-decoration: none;
  font-weight: 700;
  font-size: 0.85rem;
  border-bottom: 1px solid var(--text-primary);
  padding-bottom: 4px;
  transition: color 0.2s ease, border-color 0.2s ease;

  &:hover {
    color: var(--accent);
    border-color: var(--accent);
  }

  svg {
    margin-left: 8px;
  }
`;

export default About;
